var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirocard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 561.26001 561.26532",
    height: 561.26532,
    width: 561.26001,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,420.949 H 420.945 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,561.26533)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(385.1833,91.677)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.289,10.415 -0.289,17.82 -0.289,28.287 0,13.056 0.217,26.12 0.289,39.16 H -9.62 V 35.138 c -1.546,1.875 -1.907,2.38 -3.043,3.428 -2.616,2.283 -6.935,4.888 -13.276,4.888 -1.859,0 -10.367,-0.112 -17.014,-7.385 -8.047,-8.641 -7.38,-20.328 -7.38,-22.074 0.128,-3.753 0.614,-7.935 2.159,-11.812 2.589,-6.666 8.717,-14.89 21.42,-14.89 1.369,0 8.777,0 14.38,5.551 1.024,0.827 1.718,1.75 3.332,3.929 l 0.417,-8.228 H 0.441 C 0.193,-7.156 0.152,-4.258 0,0 m -9.452,15.023 c 0,-0.964 -0.072,-4.207 -1.108,-7.51 -2.516,-7.613 -8.215,-11.771 -14.573,-11.771 -5.129,0 -10.254,2.805 -13.104,8.874 -1.577,3.395 -2.195,7.28 -1.986,11.029 0,1.348 0.072,4.483 1.4,8.308 3.508,10.009 11.463,10.989 14.1,10.989 6.12,0 11.739,-4.11 14.163,-11.555 0.41,-1.586 1.229,-4.491 1.108,-8.364 M -57.044,34.42 c 2.617,0 3.937,-0.462 6.534,-1.288 v 9.463 c -0.49,0 -3.391,0.45 -5.816,0.45 -3.905,0 -8.857,-0.943 -12.662,-5.527 -0.646,-0.73 -1.517,-2.183 -2.657,-4.081 l -0.482,8.982 h -9.09 c 0.317,-6.755 0.481,-11.463 0.481,-18.117 0,-7.806 -0.044,-13.313 -0.044,-21.043 v -14.714 h 9.761 v 26.373 c 0.341,5.109 0.578,11.872 5.836,16.468 3.499,3.034 6.939,3.034 8.139,3.034 m -43.286,-45.875 h 8.232 v 37.611 c -0.771,4.728 -1.252,7.108 -2.697,9.283 -2.81,4.704 -8.95,8.015 -17.411,8.015 -1.561,0 -7.734,0 -13.485,-2.685 -1.208,-0.626 -2.111,-1.244 -3.412,-1.866 v -8.469 c 2.204,1.253 8.389,5.106 15.083,5.106 6.538,0 10.568,-3.761 11.916,-7.281 0.775,-2.203 0.891,-4.888 0.972,-7.108 -2.493,0.125 -5.15,0.225 -7.738,0.225 -5.314,0 -11.676,-0.225 -16.994,-2.83 -4.13,-1.978 -9.785,-5.803 -9.785,-14.436 0,-0.943 0.117,-1.999 0.342,-3.083 0.573,-3.752 2.412,-7.152 5.097,-9.427 3.022,-2.561 7.076,-3.556 11.193,-3.805 6.145,-0.181 10.315,1.698 12.98,3.58 2.292,1.746 3.693,3.423 5.707,5.723 z m -0.566,24.27 c 0,-3.556 -0.317,-5.627 -0.818,-7.28 -0.197,-0.719 -0.815,-2.509 -2.412,-4.604 -3.127,-4.254 -7.237,-5.707 -11.094,-5.707 -4.431,0 -10.327,2.308 -10.327,8.633 0,6.281 5.507,8.958 10.327,10.138 1.453,0.297 3.745,0.574 7.084,0.574 2.412,0 4.828,-0.072 7.24,-0.277 z m -51.24,-25.096 c 6.462,0 9.957,1.445 12.976,2.797 l -0.723,8.661 c -1.862,-0.819 -6.116,-2.902 -11.238,-2.902 -0.726,0 -4.061,0 -6.835,1.469 -8.171,4.038 -10.178,12.274 -10.178,18.402 0,9.055 4.543,14.288 9.131,16.797 4.158,2.328 7.882,2.195 9.379,2.195 3.821,-0.192 6.839,-1.549 8.369,-2.303 l 0.501,8.761 c -1.714,0.425 -5.723,1.754 -10.367,1.858 -10.78,0.321 -17.519,-4.684 -21.464,-9.865 -4.499,-5.876 -5.703,-13.044 -5.51,-19.02 0.385,-14.32 8.556,-22.046 15.716,-24.948 1.903,-0.859 5.31,-1.826 10.243,-1.902 m -39.734,6.754 c 6.229,6.278 8.019,14.814 7.927,21.705 -0.293,13.237 -7.224,21.136 -13.787,24.591 -2.287,1.128 -6.225,2.581 -11.739,2.581 -12.085,0 -19.847,-6.261 -23.563,-12.699 -2.641,-4.595 -3.605,-9.905 -3.749,-15.331 -0.1,-10.817 3.749,-17.186 8.36,-21.669 1.116,-0.932 2.224,-1.79 3.432,-2.509 3.018,-1.978 7.348,-3.624 14.476,-3.624 5.467,0 9.067,1.027 11.387,2.103 2.42,1.028 5.053,2.677 7.256,4.852 m -2.107,21.525 c 0,-5.888 -1.83,-14.513 -9.062,-18.595 -1.449,-0.726 -3.938,-1.886 -7.474,-1.886 -0.794,0 -3.72,0.104 -6.522,1.461 -0.606,0.325 -1.208,0.65 -2.64,1.702 -1.469,1.103 -3.5,3.327 -5.118,7.079 -1.404,3.304 -1.882,6.855 -1.79,10.419 0.173,7.47 3.283,12.779 6.53,15.509 2.127,1.778 5.531,3.853 10.584,3.853 8.34,-0.101 12.036,-5.828 13.867,-10.207 0.59,-1.577 1.625,-5.085 1.625,-9.335 m -49.531,18.422 c 2.613,0 3.946,-0.462 6.53,-1.288 v 9.463 c -0.477,0 -3.383,0.45 -5.799,0.45 -3.937,0 -8.874,-0.943 -12.691,-5.527 -0.598,-0.73 -1.525,-2.183 -2.633,-4.081 l -0.485,8.982 h -9.063 c 0.289,-6.755 0.534,-11.463 0.534,-18.117 0,-7.806 -0.149,-13.313 -0.149,-21.043 v -14.714 h 9.785 v 26.373 c 0.293,5.109 0.59,11.872 5.828,16.468 3.504,3.034 6.939,3.034 8.143,3.034 m -45.3,20.818 h 10.375 v 10.636 h -10.375 z m -15.849,-81.783 c 4.013,5.301 4.33,10.804 4.619,22.094 l -0.12,46.87 h -9.023 v -8.324 c -0.309,0.497 -2.051,3.219 -4.35,5.077 -2.388,2.099 -6.831,4.399 -12.884,4.302 -5.41,0 -9.672,-2.071 -11.771,-3.451 -3.5,-2.312 -5.334,-4.688 -6.334,-6.177 -4.222,-5.816 -5.342,-12.795 -5.342,-18.723 0,-1.485 0,-6.582 1.598,-11.362 0.413,-1.353 2.223,-7.381 7.545,-11.864 2.95,-2.404 7.461,-4.804 14.304,-4.479 3.821,0.196 9.063,1.449 12.884,4.675 1.216,1.048 1.934,1.754 3.628,4.062 l -0.076,-7.393 c -0.213,-2.4 -0.338,-4.8 -1.253,-7.176 -0.481,-1.477 -1.308,-2.83 -2.416,-4.086 -2.588,-2.994 -5.9,-4.551 -12.253,-4.776 -6.241,0 -11.366,1.477 -13.71,2.288 -2.589,0.943 -4.206,1.971 -5.322,2.593 l -1.003,-9.384 c 1.517,-0.61 2.632,-1.023 4.25,-1.577 2.589,-0.823 8.264,-2.276 15.175,-2.276 7.449,0 12.185,1.702 15.404,3.448 3.556,2.079 5.241,3.957 6.45,5.639 m -4.833,41.668 c 0,-1.353 0,-6.695 -3.114,-11.567 -3.223,-5.081 -8.059,-7.505 -12.286,-7.505 -3.624,0 -7.348,1.569 -9.885,3.949 -3.797,3.761 -4.904,9.793 -4.904,15.552 0.068,8.132 2.412,12.707 6.257,16.227 1.477,1.485 4.495,3.444 8.44,3.444 2.701,0 6.117,-1.036 8.938,-3.312 6.863,-5.735 6.554,-16.266 6.554,-16.788 m 30.792,27.296 h -9.476 v -53.881 h 9.476 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.3475,286.0889)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.134,1.567 -1.01,2.064 -1.958,2.064 h -17.715 c -1.037,0 -1.807,-0.413 -1.963,-2.388 l -0.631,-14.039 c 0,-0.836 0.603,-2.058 1.886,-2.058 h 19.143 c 1.21,0 1.874,1.171 1.874,2.159 z m -11.892,-12.701 c -1.121,0 -1.813,0.196 -3.096,0.419 0.062,0.468 0.123,0.976 0.134,1.506 0.681,-0.301 2.008,-0.491 2.795,-0.491 1.327,0 3.257,0.474 3.257,2.37 0,2.103 -2.225,2.388 -3.419,2.388 -0.151,0 -0.502,0.028 -1.327,-0.062 -0.396,-0.033 -1.177,-0.301 -1.177,-0.301 v 5.801 h 7.574 v -1.171 h -5.734 v -2.951 c 0.056,-0.056 0.391,0.022 0.636,0.05 0.368,0.017 0.775,0.034 0.915,0.034 2.142,0 4.708,-1.071 4.708,-3.726 0,-3.146 -3.565,-3.866 -5.266,-3.866"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248.3836,285.7018)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.195,1.322 -1.16,2.449 -2.32,2.449 h -17.732 c -1.021,0 -1.69,-0.988 -1.69,-1.746 l 1.009,-14.675 c 0.151,-1.4 1.389,-2.064 2.22,-2.064 H 0.608 c 1.004,0.072 1.712,0.831 1.712,1.668 C 2.32,-14.201 0.653,-4.752 0,0 m -9.399,-12.31 c -3.971,0 -5.243,3.519 -5.243,6.437 0,3.263 1.244,5.404 5.031,5.404 0.876,0 1.947,-0.211 2.789,-0.457 -0.044,-0.413 -0.106,-0.848 -0.134,-1.322 -0.541,0.318 -1.757,0.491 -2.398,0.491 -1.891,0 -3.257,-0.881 -3.43,-3.436 v -0.68 c 0.396,0.82 2.147,1.216 2.961,1.216 2.293,0 4.552,-1.73 4.552,-4.184 0,-2.699 -2.259,-3.469 -4.128,-3.469"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.2861,279.7096)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.445,0 -2.259,-0.987 -2.259,-2.276 0,-1.266 1.155,-2.75 2.8,-2.75 1.238,0 2.231,0.82 2.231,2.259 C 2.772,-1.383 1.567,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.813,264.5759)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -19.45 c -2.136,0 -2.292,-1.205 -2.454,-2.426 -0.218,-1.584 -2.75,-17.029 -2.778,-17.197 -0.29,-1.762 0.636,-3.056 1.785,-3.056 h 21.101 c 1.991,0.061 2.354,1.478 2.538,3.084 L 1.947,-1.991 C 1.947,-1.077 1.205,0 0,0 m -5.455,-4.786 -7.285,-13.325 h -2.471 l 7.397,12.567 h -7.274 c 0.056,0.68 0.123,1.138 0.195,1.589 h 9.438 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.4357,262.4602)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0.072,1.11 -1.238,2.114 -2.147,2.114 h -19.517 c -0.815,0 -2.109,-0.926 -2.131,-1.991 l -0.853,-18.268 c 0,-1.009 0.859,-2.42 2.225,-2.42 h 21.107 c 1.45,0 2.147,1.522 2.147,2.487 z m -11.976,-15.992 c -2.125,0 -5.198,1.11 -5.198,4.061 0,1.835 1.261,2.995 3.386,3.905 -1.88,0.853 -2.616,1.74 -2.616,3.184 0,2.778 2.928,3.33 4.624,3.33 1.539,0 4.88,-0.429 4.88,-3.218 0,-1.4 -1.221,-2.649 -2.738,-3.347 2.192,-0.909 3.056,-2.37 3.056,-3.915 0,-3.219 -3.341,-4 -5.394,-4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.7196,255.0345)",
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0.937,0 2.627,1.818 2.644,2.616 2.683,4.066 1.06,4.512 0.134,4.512 -0.814,4.512 -2.516,4.189 -2.516,2.7 -2.516,1.818 -0.937,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.5288,253.5787)",
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.266,0 -3.023,-2.108 -3.023,-3.018 0,-1.784 1.757,-2.51 3.023,-2.51 1.205,0 3.096,0.558 3.096,2.399 C 3.096,-1.88 1.355,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252.0722,262.6454)",
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.273,1.355 -1.166,1.896 -2.309,1.93 h -19.506 c -1.043,0 -1.958,-1.082 -1.958,-1.93 0,-0.167 1.322,-17.392 1.322,-17.392 0.168,-1.801 0.469,-3.357 2.488,-3.357 H 1.132 c 1.127,0 1.902,1.02 1.902,2.097 C 3.034,-18.513 1.054,-5.098 0,0 m -5.784,-11.128 c -0.53,-3.943 -2.75,-5.053 -5.6,-5.053 -0.876,0 -2.46,0.206 -3.124,0.524 0.056,0.987 0.117,1.344 0.14,1.74 0.853,-0.323 1.941,-0.613 2.755,-0.613 2.767,0 3.787,2.387 3.787,4.39 0,0.139 0.012,0.596 -0.089,0.881 -1.043,-1.339 -1.935,-1.395 -2.945,-1.395 -2.878,0 -5.265,1.93 -5.265,4.981 0,2.895 2.281,3.977 4.573,3.977 3.927,0 5.338,-3.162 5.768,-7.273 0.1,-0.865 0.134,-1.277 0,-2.159"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.6444,259.4901)",
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.612,0 -2.521,-1.049 -2.521,-2.583 0,-1.517 1.266,-3.329 3.034,-3.329 1.54,0 2.46,1.07 2.46,2.554 C 2.973,-1.79 2.053,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.0072,192.889)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -29.707,124.061 h -0.117 l -0.017,0.073 H -43.11 l 0.011,-2.024 h 0.133 l 10e-4,-0.073 h 11.094 L -3.207,2.354 l -140.019,0.061 28.435,119.622 h 11.27 l -0.038,2.024 h -0.133 l -0.001,0.073 h -13.273 L -146.701,0.123 h 0.151 l -0.018,-0.073 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.6684,364.4647)",
    id: "g68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#62c6e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.667,0.301 -1.394,0.487 -2.17,0.487 h -49.749 c -2.95,0 -5.349,-2.404 -5.349,-5.36 l 0.011,-48.666 h 0.134 v -0.073 h 3.62 l -0.011,48.666 c 0,0.965 0.775,1.752 1.729,1.752 h 9.103 v -35.408 h -10.219 l 13.761,-14.881 h 0.066 l 0.068,-0.073 h 24.191 l 13.743,14.881 h -0.201 l 0.067,0.073 h -10.067 v 35.408 h 9.236 c 0.418,0 0.781,-0.204 1.083,-0.466 0.305,-0.318 0.502,-0.746 0.502,-1.213 v -48.666 h 0.133 v -0.073 h 3.62 V -4.946 C 3.301,-2.715 1.933,-0.806 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.2331,235.402)",
    id: "g72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.313,0.167 -0.658,0.28 -1.044,0.28 h -21.241 c -1.55,-0.106 -2.666,-0.641 -2.85,-2.37 -0.195,-1.986 -3.848,-23.416 -3.876,-23.583 -0.155,-0.774 0.357,-1.873 1.249,-2.346 0.298,-0.188 0.636,-0.315 1.021,-0.315 h 23.783 c 1.523,0 2.879,2.036 2.845,3.402 L 1.488,-2.236 C 1.488,-1.354 0.898,-0.404 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.9956,232.9767)",
    id: "g76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.146,1.323 -0.762,2.143 -1.79,2.47 -2.168,2.613 -2.588,2.705 -3.084,2.705 H -24.33 c -1.69,0 -2.337,-1.383 -2.337,-2.632 0,0 1.751,-23.661 1.623,-22.986 0.16,-1.449 0.82,-2.375 1.797,-2.741 0.35,-0.156 0.733,-0.255 1.165,-0.255 H 1.567 c 1.406,0 2.148,1.523 2.148,2.588 C 3.715,-23.153 0.848,-7.424 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.4196,228.9547)",
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.288,0.139 -0.6,0.232 -0.958,0.232 -2.94,-0.017 -3.219,-3.888 -3.291,-6.883 -0.069,-2.731 0.193,-6.289 2.289,-7.11 0.322,-0.152 0.68,-0.253 1.102,-0.253 2.889,0 3.246,4.345 3.246,7.58 C 2.388,-3.916 1.838,-0.731 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.399,212.9247)",
    id: "g84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.102,-0.004 -2.005,0.206 -2.753,0.594 -2.226,1.254 -2.962,4.216 -3.037,8.302 -0.033,1.869 0.151,3.894 0.798,5.562 h -0.04 l 0.031,10e-4 c 0.831,2.164 2.416,3.748 5.288,3.748 1.357,0.014 2.404,-0.318 3.229,-0.908 C 4.35,16.656 4.932,15.72 5.324,14.543 H 5.328 C 5.813,13.082 6.018,11.299 6.046,9.259 6.152,4.066 4.752,0 0,0 m 13.665,14.474 h -0.011 l -0.214,4.994 c 0.128,1.149 -0.584,2.394 -1.625,2.921 -0.354,0.207 -0.743,0.342 -1.164,0.342 h -21.302 c -1.043,0 -2.404,-0.959 -2.594,-2.309 l -0.254,-5.875 h -0.016 l -0.803,-17.224 c 0,-0.679 0.357,-2.136 1.375,-2.78 0.328,-0.242 0.723,-0.405 1.218,-0.405 h 23.717 c 1.707,0 2.46,2.035 2.46,3.157 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.3245,297.0454)",
    id: "g88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0.742,-0.178 1.361,-0.385 2.008,-0.429 0.764,-0.062 0.948,-0.062 1.116,-0.062 0.808,0 2.621,0.084 2.621,1.612 0,0.762 -0.553,1.229 -1.196,1.511 C 3.912,2.949 3.157,3.074 2.745,3.079 H 1.216 c 0.043,0.332 0,0.679 0.006,1.065 h 1.405 c 0.631,0 2.46,0.447 2.46,1.428 0,0.752 -0.534,1.14 -1.142,1.343 -0.63,0.25 -1.371,0.292 -1.697,0.292 -0.737,0 -1.638,-0.206 -2.511,-0.425 -0.069,0.263 -0.132,0.541 -0.178,0.965 0.586,0.207 1.144,0.335 1.875,0.397 0.797,0.083 2.035,0 2.035,0 0.494,0 1.317,-0.185 2.04,-0.567 C 6.228,7.161 6.822,6.535 6.822,5.645 6.822,4.463 5.745,3.933 4.463,3.671 4.53,3.658 4.591,3.63 4.658,3.615 4.636,3.61 4.618,3.602 4.596,3.598 4.996,3.523 5.391,3.414 5.758,3.268 6.795,2.82 7.592,2.074 7.592,0.937 c 0,-2.219 -3.531,-2.504 -4.418,-2.504 -1.081,0 -2.107,0.201 -3.174,0.439 z m 12.478,9.583 c -0.072,0.365 -0.381,0.639 -0.792,0.831 -0.381,0.217 -0.865,0.351 -1.395,0.351 H -5.321 c -0.608,0 -1.891,-0.407 -1.891,-1.472 l 0.82,-11.797 c 0.124,-1.038 0.451,-1.549 0.853,-1.822 0.346,-0.299 0.768,-0.365 1.188,-0.365 H 13.22 c 0.976,0.039 1.455,0.736 1.455,1.467 0,0.151 -1.394,8.551 -2.197,12.807"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.5452,296.9868)",
    id: "g92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0.513,0.323 5.807,3.425 5.807,5.438 5.807,6.171 5.349,6.543 4.823,6.736 4.292,6.976 3.658,7.017 3.336,7.017 2.544,7.017 1.574,6.806 0.636,6.466 0.565,6.835 0.498,7.178 0.452,7.541 1.601,7.87 2.806,8.071 3.882,8.071 4.611,8.071 5.53,7.93 6.289,7.555 7.03,7.148 7.592,6.499 7.592,5.472 7.592,3.012 3.096,0.932 1.707,-0.357 H 1.932 C 1.905,-0.38 1.865,-0.407 1.841,-0.429 H 7.924 C 7.906,-0.717 7.905,-1 7.926,-1.5 H 0 Z m 13.839,9.254 c -0.007,0.567 -0.399,0.943 -0.868,1.181 -0.44,0.262 -0.978,0.386 -1.347,0.386 H -3.988 c -0.77,0 -1.952,-0.413 -2.008,-1.69 L -6.587,-2.85 c 0,-0.557 0.419,-1.261 1.048,-1.557 0.219,-0.131 0.46,-0.223 0.731,-0.223 h 17.603 c 0.609,0 1.629,0.748 1.629,1.584 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.4241,295.4889)",
    id: "g96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -1.692 l 0.956,7.87 C -0.779,7.85 -0.841,7.818 -0.888,7.794 L -0.87,7.943 C -1.507,7.637 -2.752,6.983 -2.854,6.93 L -3.62,7.641 -0.268,9.432 H 1.024 Z M 8.338,12.115 C 8.081,12.238 7.777,12.322 7.374,12.322 H -8.239 c -1.539,0 -1.991,-0.458 -2.13,-1.233 -0.77,-4.178 -2.031,-12.533 -2.053,-12.684 -0.092,-0.619 0.12,-0.988 0.464,-1.209 0.272,-0.234 0.673,-0.331 1.109,-0.331 H 6.744 c 0.708,0 1.628,0.335 1.818,1.93 -0.028,-0.658 0.776,11.602 0.776,11.602 0,0.806 -0.268,1.452 -1,1.718"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.4869,277.4482)",
    id: "g100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -0.007,-0.073 H 1.519 C 1.518,-0.658 1.463,-1.034 1.521,-1.422 H -0.208 C -0.32,-2.22 -0.442,-3.051 -0.526,-3.96 H -2.41 l 0.25,2.465 h -0.142 l 0.008,0.073 H -8.08 c 0.06,0.498 0.185,1.394 0.185,1.394 0,0 4.195,5.014 6.382,7.496 H 0.61 L -0.141,0 Z m 8.934,9.08 c 0,0.591 -0.498,1.222 -1.116,1.488 -0.227,0.122 -0.469,0.208 -0.719,0.208 h -17.715 c -1.216,0 -1.88,-0.664 -2.248,-1.623 -0.597,-1.489 -2.214,-14.34 -2.242,-14.508 -0.143,-1.088 0.4,-1.891 1.052,-2.201 0.226,-0.137 0.466,-0.225 0.705,-0.225 H 5.766 c 1.221,0 1.952,0.73 2.147,2.13 C 7.818,-6.337 8.934,9.08 8.934,9.08"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.1813,283.4053)",
    id: "g104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#004090",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -4.758,-6.013 h 0.194 l -0.058,-0.074 h 4.077 l 0.681,6.013 -0.168,-0.212 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirocard);
export default __webpack_public_path__ + "static/media/girocard.bebadbf393eef2bf5fdb38c2a251e2e0.svg";
export { ForwardRef as ReactComponent };